import { useCallback } from "react";
import { FrontendStatusCode } from "./error-types";
import { useErrorMessageTranslationsT } from "src/translation-hooks/error-message-translations";

export const useFrontendErrorTranslation = () => {
  const errorMessageTranslationsT = useErrorMessageTranslationsT();

  const getFrontendErrorTranslation = useCallback(
    (frontendStatusCode: FrontendStatusCode) => {
      switch (frontendStatusCode) {
        case "invalid-user":
          return errorMessageTranslationsT.invalidUser;
        default:
          const assertNever: never = frontendStatusCode;
          return assertNever;
      }
    },
    [errorMessageTranslationsT]
  );

  return { getFrontendErrorTranslation };
};
